
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.84 52.25c-12.409 0-22.497-10.044-22.497-22.4 0-12.355 10.088-22.4 22.496-22.4s22.497 10.045 22.497 22.4c0 12.355-10.089 22.4-22.497 22.4zm0-42.809c-11.299 0-20.498 9.16-20.498 20.41S18.541 50.26 29.84 50.26c11.299 0 20.497-9.16 20.497-20.41S41.148 9.442 29.84 9.442z"}}),_c('path',{attrs:{"d":"M31.01 31.98h-9.92a1 1 0 01-1-.995 1 1 0 011-.995h8.92V17.545a1 1 0 011.999 0v13.44c0 .558-.45.996-1 .996z"}})])
          )
        }
      }
    